module.exports = __webpack_public_path__ + "img/fail.64c3c878.png";